import React from 'react'
import styles from './Button.module.css'

const Button = ({
  onClick,
  children,
  icon,
  width,
  bgColor,
  type,
  outlined,
  small,
  textLight,
  ...otherButtonProps
}) => {
  const background = bgColor || '#F49832'
  const myStyle = {
    width: width || '100%',
    backgroundColor: background,
    border: `1px solid ${background}`
  }
  const handleClick = e => {
    onClick && onClick(e)
  }
  const generateClassName = () => {
    let result = `${styles['button']} `

    if (icon) {
      result += `${styles['has-icon']} `
    }

    if (outlined) {
      result += `${styles['outlined']} `
    }

    if (small) {
      result += `${styles['small']} `
    }

    if (textLight) {
      result += `${styles['textLight']}`
    }

    return result
  }

  return (
    <>
      <button
        className={generateClassName()}
        type={type}
        onClick={handleClick}
        style={myStyle}
        {...otherButtonProps}
      >
        {!!icon && <img src={icon} alt='icon' />}
        {children}
      </button>
    </>
  )
}

export default Button
